export class OpnBoardMembersListModel {
  id: number;
  requestId: number;
  userId: number;
  fullName: string;
  employeePositionErpId: string;
  employeePositionName: string;
  personnelAreaErpId: string;
  personnelAreaName: string;
  isGivenCompliance: boolean;
  complianceDate: Date;
}


export class OpnBoardMembersSaveModel {
  requestId: number;
  userId:  number;
}

